import React, {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {FormProvider, useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {schemaExportFormData} from '../../../../../../util/validation'
import {
  getCompany,
  getClient,
  getSite,
  getExportRDataReportXLS,
  getExportRDataReportCSV,
  getExportRDataReportPDF,
} from '../../../../services'
import {MasterModel, ExportDataFormModel} from '../../../../model'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {Select} from '../../../../../../components/UI/Select'
import {InputDateForm} from '../../../../../../components/UI/Input'
import {ButtonWrapper, Button} from '../../../../../../components/UI/Button'
import {donwloadFile} from '../../../../../lavanderia/helpers/utilities'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  dataValidate?: any
  columns?: any[]
}
const downloadReportForType = {
  pdf: getExportRDataReportPDF,
  xlsx: getExportRDataReportXLS,
  csv: getExportRDataReportCSV,
}
type TypeDownloadReport = keyof typeof downloadReportForType
const ModalExportData: FC<Props> = ({show, setShow, dataValidate, columns}) => {
  const [company, setCompany] = useState<MasterModel[] | any>([])
  const [client, setClient] = useState<MasterModel[] | any>([])
  const [site, setSite] = useState<MasterModel[] | any>([])
  const [idAll, setIdAll] = useState<string | number>('')
  const methods = useForm<ExportDataFormModel>({
    resolver: yupResolver(schemaExportFormData),
  })

  const {
    control,
    setValue,
    setError,
    register,
    handleSubmit,
    reset,
    watch,
    formState: {errors},
  } = methods
  const getCompanyList = async () => {
    try {
      const response = await getCompany({isCombo: true}, 1)
      let data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombreEmpresa}))
      const mappedSitesFilter = [...mappedSites]
      const getAll = mappedSitesFilter.filter((item) => item.label === 'TODOS')
      if (getAll.length > 0) {
        setIdAll(getAll[0].value || '')
      }
      setCompany(mappedSites)
    } catch (error) {}
  }
  const getClientList = async (id: any) => {
    try {
      const response = await getClient({isCombo: true, companiaId: id}, 1)
      let data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
      const mappedSitesFilter = [...mappedSites]
      const hasAll = mappedSitesFilter.filter((item) => item.value === idAll)
      if (idAll !== '' && hasAll.length === 0) {
        mappedSites.push({value: idAll, label: 'TODOS'})
      }
      setClient(mappedSites)
    } catch (error) {}
  }
  const getSiteList = async (id: any) => {
    try {
      const response = await getSite({isCombo: true, clienteId: id}, 1)
      let data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
      const mappedSitesFilter = [...mappedSites]
      const hasAll = mappedSitesFilter.filter((item) => item.value === idAll)
      if (idAll !== '' && hasAll.length === 0) {
        mappedSites.push({value: idAll, label: 'TODOS'})
      }
      setSite(mappedSites)
    } catch (error) {}
  }
  useEffect(() => {
    if (dataValidate) {
      if (dataValidate.company) {
        setValue('isCompany', 'SI')
      }
      if (dataValidate.client) {
        setValue('isClient', 'SI')
      }
      if (dataValidate.site) {
        setValue('isSite', 'SI')
      }
    }
  }, [dataValidate])
  useEffect(() => {
    getCompanyList()
    setValue('isCompany', 'NO')
    setValue('isClient', 'NO')
    setValue('isSite', 'NO')
  }, [])

  const handleClose = () => {
    setShow(false)
    reset()
    setIdAll('')
    setClient([])
    setSite([])
  }

  const handleGetClient = async (val: any) => {
    let value = val ? val : ''
    setValue('companiaId', value.value)
    setError('companiaId', {})
    setValue('clienteId', '')
    setError('clienteId', {})
    setValue('siteId', '')
    setError('siteId', {})
    getClientList(value.value)
  }
  const handleGetSite = async (val: any) => {
    setSite([])
    let value = val ? val : ''
    getSiteList(value.value)
    setValue('clienteId', value.value)
    setError('clienteId', {})
    setValue('siteId', '')
    setError('siteId', {})
  }
  const handleDownloadReport = async (typeFormat: TypeDownloadReport) => {
    let data = {}
    // if (formValue) {
    const {aplicacion, tabla, campos} = dataValidate
    let inicio = watch('fechaInicio')
    let fin = watch('fechaFin')
    data = {
      aplicacion,
      tabla,
      campos,
      companiaId: watch('companiaId'),
      clienteId: watch('clienteId'),
      siteId: watch('siteId'),
      fechaInicio: inicio ? new Date(inicio) : '',
      fechaFin: fin ? new Date(fin) : '',
    }
    // }
    const response = (await downloadReportForType[typeFormat](data)) as any
    await donwloadFile(response.data, typeFormat)
  }
  console.log(errors)
  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormProvider {...methods}>
            <form>
              <div className='row'>
                {dataValidate.company && (
                  <div className='mb-2 col-sm-12 col--6  d-flex justify-content-between'>
                    <label className='required form-label align-content-center me-3'>
                      Compañía
                    </label>
                    <Select
                      control={control}
                      name='companiaId'
                      data={company}
                      errors={errors}
                      onChangeValue={handleGetClient}
                    />
                  </div>
                )}
                {dataValidate.client && (
                  <div className='mb-2 col-sm-12 col--6 d-flex justify-content-between'>
                    <label className='required form-label  align-content-center me-3'>
                      Cliente
                    </label>
                    <Select
                      control={control}
                      name='clienteId'
                      data={client}
                      errors={errors}
                      onChangeValue={handleGetSite}
                      disabled={client.length === 0}
                    />
                  </div>
                )}
                {dataValidate.site && (
                  <div className='mb-2 col-sm-12 col--6 d-flex justify-content-between'>
                    <label className='required form-label  align-content-center me-3'>Site</label>
                    <Select
                      control={control}
                      name='siteId'
                      data={site}
                      errors={errors}
                      disabled={site.length === 0}
                    />
                  </div>
                )}
              </div>
              <div className='row'>
                <div className='col-sm-12 col-lg-9 d-flex justify-content-between'>
                  <label className='required form-label align-content-center me-3'>
                    Fecha registro:
                  </label>

                  <InputDateForm name='fechaInicio' register={register} errors={errors} />
                  <span className='form-label align-content-center me-3'>al</span>
                  <InputDateForm name='fechaFin' register={register} errors={errors} />
                </div>
              </div>

              <div className='d-flex justify-content-center mb-3'>
                <ButtonWrapper className='sdx-white-bg overflow-visible justify-content-start'>
                  <Button
                    label='Exportar Excel'
                    onClick={handleSubmit(() => handleDownloadReport('xlsx'))}
                  />
                  <Button
                    label='Exportar CSV'
                    onClick={handleSubmit(() => handleDownloadReport('csv'))}
                  />
                  <Button
                    label='Exportar PDF'
                    onClick={handleSubmit(() => handleDownloadReport('pdf'))}
                  />

                  <Button label='Cancelar' onClick={() => handleClose()} />
                </ButtonWrapper>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </Modal>
  )
}

export {ModalExportData}
